import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NewMemberSubscriptionVariables = Types.Exact<{
  uuid: Types.Scalars['String']['input'];
}>;


export type NewMemberSubscription = { __typename?: 'Subscription', newMemberInOrganisation: { __typename?: 'NewMemberInOrganisation', member: { __typename?: 'OrganisationMemberUser', id: string } } };


export const NewMemberDocument = gql`
    subscription NewMember($uuid: String!) {
  newMemberInOrganisation(input: {uuid: $uuid}) {
    member {
      id
    }
  }
}
    `;

/**
 * __useNewMemberSubscription__
 *
 * To run a query within a React component, call `useNewMemberSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewMemberSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewMemberSubscription({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useNewMemberSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewMemberSubscription, NewMemberSubscriptionVariables> & ({ variables: NewMemberSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewMemberSubscription, NewMemberSubscriptionVariables>(NewMemberDocument, options);
      }
export type NewMemberSubscriptionHookResult = ReturnType<typeof useNewMemberSubscription>;
export type NewMemberSubscriptionResult = Apollo.SubscriptionResult<NewMemberSubscription>;